import { Component, OnInit } from "@angular/core";
import {
    MatTableDataSource,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import * as moment from "moment";

interface FailureReasonCount {
    reason: string;
    count: number;
}

interface SportDecisionSummary {
    sportId: string;
    sportName: string;
    eventsCount: number;
    successCount: number;
    failureCount: number;
    failureReasons: FailureReasonCount[];
}

@Component({
    selector: "app-sport-arbitrage-decisions",
    templateUrl: "./sport-arbitrage-decisions.component.html",
    styleUrls: ["./sport-arbitrage-decisions.component.scss"],
})
export class SportArbitrageDecisionsComponent implements OnInit {
    selected: any = { startDate: null, endDate: null };
    userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
    sportDecisionsList = new MatTableDataSource<SportDecisionSummary>([]);
    displayedColumns: string[] = [
        "sportName",
        "eventsCount",
        "successCount",
        "failureCount",
    ];
    loading: boolean = false;
    expandedElement: SportDecisionSummary | null = null;

    startOfDay = moment().subtract(1, "days").startOf("day");
    endOfDay = moment().subtract(1, "days").endOf("day");
    ranges: any = {
        Today: [moment().startOf("day"), moment().endOf("day")],
        Yesterday: [moment(this.startOfDay), moment(this.endOfDay)],
        "Last 7 Days": [
            moment(moment().subtract(6, "days").startOf("day")),
            moment(),
        ],
        "Last 30 Days": [
            moment(moment().subtract(29, "days").startOf("day")),
            moment(),
        ],
        "This Month": [moment().startOf("month"), moment()],
        "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
        ],
    };

    constructor(private appService: AppService, private router: Router) { }

    ngOnInit() {
        // Initialize with default date range (today)
        this.selected = {
            startDate: moment().startOf("day").toDate(),
            endDate: moment().endOf("day").toDate(),
        };
    }

    onDateChangeHandler = (event: any) => {
        this.selected = event;
    };

    applyFilters = () => {
        if (!this.selected.startDate || !this.selected.endDate) {
            this.appService.openErrorBar("Please select both start and end dates");
            return;
        }

        this.loading = true;
        const filters = {
            startTime: Math.floor(new Date(this.selected.startDate).getTime() / 1000),
            endTime: Math.floor(new Date(this.selected.endDate).getTime() / 1000),
        };

        this.appService.getSportLevelArbitrageDecisions(filters).subscribe(
            (res) => {
                this.loading = false;
                if (res.status === "RS_OK") {
                    const data = res.data || res.sportDecisions || res.decisions || [];
                    this.sportDecisionsList = new MatTableDataSource<SportDecisionSummary>(data);
                } else if (res.errorDescription === "Invalid Token!") {
                    this.appService.openErrorBar(res.errorDescription);
                    sessionStorage.clear();
                    this.router.navigateByUrl("/login");
                } else {
                    this.appService.openErrorBar(
                        res.errorDescription || "Failed to fetch arbitrage decisions"
                    );
                }
            },
            (error) => {
                this.loading = false;
                const errorMessage = (error.error && error.error.errorDescription)
                    ? error.error.errorDescription
                    : "Error fetching arbitrage decisions";
                this.appService.openErrorBar(errorMessage);
            }
        );
    };

    toggleRow(element: SportDecisionSummary) {
        this.expandedElement = this.expandedElement === element ? null : element;
    }

    isExpanded(element: SportDecisionSummary): boolean {
        return this.expandedElement === element;
    }

    navigateToEventLevel(element: SportDecisionSummary, event?: Event) {
        if (event) {
            const target = event.target as HTMLElement;
            // Don't navigate if clicking on expand button or its children
            if (target.closest('.expand-btn') || target.closest('.failure-count-cell')) {
                return;
            }
        }

        if (!element || !element.sportId) {
            return;
        }

        const queryParams = {
            sportId: element.sportId,
            sportName: element.sportName || element.sportId,
            startTime: this.selected.startDate
                ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
                : 0,
            endTime: this.selected.endDate
                ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
                : 0,
        };

        this.router.navigate(["/administration/event-arbitrage-decisions"], {
            queryParams: queryParams,
        });
    }
}

